import React, { useEffect } from 'react'
import PropTypes from 'prop-types'

import { graphql } from 'react-apollo'
import loadPage from '../LandingOrPostPage/loadPage.gql'

import Loading from '../../components/pages/Loading'
import EmailTemplatePage from '../../components/pages/EmailTemplatePage'

// Redux
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { resetGamesLegalLines } from '../../store/actions'

const EmailTemplatePageContainer = (props) => {
  useEffect(() => {
    props.resetGamesLegalLines()
  }, [])

  const { data } = props
  const { pageOrGame, loading, globalContent, globalComponents, error } = data

  if (loading) {
    return <Loading />
  }
  if (!loading && error) {
    return error
  }
  if (!pageOrGame?.page) {
    <div>Not found</div>
  }
  const { page } = pageOrGame

  return (
    <EmailTemplatePage
      customTermsAndConditions={page?.customTermsAndConditions}
      globalContent={globalContent}
      globalComponents={globalComponents}
      components={page?.components}
    />
  )
}

EmailTemplatePageContainer.propTypes = {
  data: PropTypes.shape({
    pageOrGame: PropTypes.shape({
      page: PropTypes.shape({
        customTermsAndConditions: PropTypes.string,
        components: PropTypes.array
      })
    }),
    globalContent: PropTypes.object,
    globalComponents: PropTypes.object,
    loading: PropTypes.bool,
    error: PropTypes.object
  }),
  resetGamesLegalLines: PropTypes.func
}

function mapDispatchToProps (dispatch) {
  return bindActionCreators({ resetGamesLegalLines }, dispatch)
}

const EmailTemplatePageContainerWithData = graphql(loadPage, {
  options: (props) => {
    const path = props.url || props.location.pathname || ''
    return {
      variables: {
        path:
          path === '/downloadhtml' ? '/' : path.replace('/downloadhtml', '')
      }
    }
  }
})(EmailTemplatePageContainer)

export default connect(
  null,
  mapDispatchToProps
)(EmailTemplatePageContainerWithData)
